module.controller('upgradeCardCtrl', ['$scope', '$state', '$http', '$rootScope', 'Session', 'baseURI', 'OVERLAY', 'Transform', 'SECURITY_QUESTIONS', function ($scope, $state, $http, $rootScope, Session, baseURI, OVERLAY, Transform, SECURITY_QUESTIONS){
  var upgradeUrl = baseURI + 'giftcard/upgrade';
  var profileUrl = baseURI + 'cardholder/profile';
  $scope.overlay = OVERLAY['member.home.upgrade'];
  $scope.formData = {};
  $scope.attempted = false;
  $scope.questions = SECURITY_QUESTIONS;
  $scope.formData.CardDesignId = 115;
  $scope.alert = {};
  $scope.latestAgeYear = new Date().getFullYear() - 18;

  // maximum upgrade birth year
  var currentYear = new Date().getFullYear();
  $scope.maxYear = currentYear - 10;

  getProfile();

  $scope.attemptSubmission = function(upgradeForm, next){
    if(!upgradeForm.$valid){
      $scope.attempted = true;
    } else {
      if(next){
        $state.go(next);
      } else {
        upgradeCard();
      }
    }
  };

  $scope.range = function (min, max, reverse){
    var options = [];
    for(var i = min; i <= max; i++){
      options.push(i);
    }
    return (reverse ? options.reverse() : options);
  };

  var upgradeCard = function(){
    $scope.loading = true;

    var ssn = $scope.formData.Ssn1 + $scope.formData.Ssn2 + $scope.formData.Ssn3;

    var dobDay = ($scope.formData.Dob2 < 10 ? ('0' + $scope.formData.Dob2) : $scope.formData.Dob2);
    var dobMonth = ($scope.formData.Dob1 < 10 ? ('0' + $scope.formData.Dob1) : $scope.formData.Dob1);
    var dob = dobMonth + '/' + dobDay + '/' + $scope.formData.Dob3;

    var upgradeRequest = {
      FirstName: $scope.formData.FirstName,
      LastName: $scope.formData.LastName,
      StreetAddress: $scope.formData.StreetAddress,
      SuiteNumber: $scope.formData.SuiteNumber || '',
      City: $scope.formData.City,
      State: $scope.formData.State,
      Zipcode: $scope.formData.Zip,
      Ssn: ssn,
      Dob: dob,
      CardDesignId: $scope.formData.CardDesignId,
      SecurityQuestion1: $scope.formData.SecurityQuestionOption1.key,
      SecurityQuestion2: $scope.formData.SecurityQuestionOption2.key,
      SecurityAnswer1: $scope.formData.answer1,
      SecurityAnswer2: $scope.formData.answer2
    };

    $http({
      method: 'POST',
      url: upgradeUrl,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(upgradeRequest)
    }).then(function (resp){
      var data = resp.data;

      $scope.loading = false;
      if(data.Success){
        $state.go('member.home.upgrade.success');
      } else {
        // if error code 150 CIP error
        if(data.ErrorCode == 150){
          $state.go('member.home.upgrade.cipFailure');
        } else {
          $scope.alert.alertShown = true;
          $scope.alert.alertMessage = 'Oops, we were unable to upgrade your account. Please verify the information is correct and try again. If you continue to have problems please call customer service ' + $scope.brand.programContactPhone + '.';
        }
      }
    }).catch(function (error){
      $scope.alert.alertShown = true;
      $scope.alert.alertMessage = 'Oops, we were unable to upgrade your account. Please verify the information is correct and try again. If you continue to have problems please call customer service ' + $scope.brand.programContactPhone + '.';
      $scope.loading = false;
    }).then(function(){
      $scope.loading = false;
    });
  };


  function getProfile(){
    $http.get(profileUrl).then(function (resp){

      var data = resp.data;
      // check if address includes hq address
      if(data.Data.Address1.indexOf('12500 SAN PEDRO AVE') === -1){
        $scope.formData.StreetAddress = data.Data.Address1;
        $scope.formData.SuiteNumber = data.Data.Address2;
        $scope.formData.City = data.Data.City;
        $scope.formData.Zip = data.Data.PostalCode;
        $scope.formData.State = data.Data.StateCode;
      }

      if(data.Data.FirstName != 'CARD RECIPIENT'){
        $scope.formData.FirstName = data.Data.FirstName;
        $scope.formData.LastName = data.Data.LastName;
      }

    }).catch(function(error){
      console.log('err', error);
    });
  }

}]);


